import { BlackHatSection } from './sections/BlackHatSection';
import { ChatSection } from './sections/ChatSection';
import { CompetitorsSection } from './sections/CompetitorsSection';
import { CustomerSection } from './sections/CustomerSection';
import { CustomerThemesSection } from './sections/CustomerThemesSection';
import { DecisionsSection } from './sections/DecisionsSection';
import { DocumentsSection } from './sections/DocumentsSection';
import { GraphSection } from './sections/GraphSection';
import { OutputsSection } from './sections/OutputsSection';
import { PastPerformanceSection } from './sections/PastPerformanceSection';
import { PlanSection } from './sections/PlanSection';
import { ProposalSection } from './sections/ProposalSection';
import { PursuitHomePage } from './sections/PursuitHomePage';
import { RfiResponsesSection } from './sections/RfiResponsesSection';
import { SolutionSection } from './sections/SolutionSection';
import { SurgerySection } from './sections/SurgerySection';
import { TeamingSection } from './sections/TeamingSection';
import { WinThemesSection } from './sections/WinThemesSection';
import { WorkstreamsSection } from './sections/WorkstreamsSection';
/** Section page per slug (§3.3). Home ('') is GRW-16's PursuitHomePage. */ export const PURSUIT_SECTION_COMPONENTS = {
    '': PursuitHomePage,
    chat: ChatSection,
    'customer/themes': CustomerThemesSection,
    customer: CustomerSection,
    competitors: CompetitorsSection,
    'black-hat': BlackHatSection,
    'win-themes': WinThemesSection,
    teaming: TeamingSection,
    'rfi-responses': RfiResponsesSection,
    proposal: ProposalSection,
    decisions: DecisionsSection,
    surgery: SurgerySection,
    documents: DocumentsSection,
    plan: PlanSection,
    solution: SolutionSection,
    outputs: OutputsSection,
    'past-performance': PastPerformanceSection,
    workstreams: WorkstreamsSection,
    graph: GraphSection
};
